/** CoStar.Api.AptsAnalytics.ViewModels.LeadType */
export var LeadType;
(function (LeadType) {
    LeadType[LeadType["None"] = 0] = "None";
    LeadType[LeadType["Email"] = 1] = "Email";
    LeadType[LeadType["Phone"] = 2] = "Phone";
    LeadType[LeadType["FinderSitesEmail"] = 3] = "FinderSitesEmail";
    LeadType[LeadType["FinderSitesPhone"] = 4] = "FinderSitesPhone";
    LeadType[LeadType["WebsiteLink"] = 5] = "WebsiteLink";
    LeadType[LeadType["Tour"] = 6] = "Tour";
    LeadType[LeadType["Application"] = 7] = "Application";
    LeadType[LeadType["RequestToApply"] = 8] = "RequestToApply";
    LeadType[LeadType["VirtualCall"] = 9] = "VirtualCall";
    LeadType[LeadType["ChatBot"] = 10] = "ChatBot";
    LeadType[LeadType["ChatBotTour"] = 11] = "ChatBotTour";
    LeadType[LeadType["AgentDirectory"] = 12] = "AgentDirectory";
    LeadType[LeadType["UnitApplication"] = 13] = "UnitApplication";
})(LeadType || (LeadType = {}));
/** CoStar.Api.AptsAnalytics.ViewModels.SortType */
export var SortType;
(function (SortType) {
    SortType[SortType["None"] = 0] = "None";
    SortType[SortType["PropertyName"] = 1] = "PropertyName";
    SortType[SortType["DateTime"] = 2] = "DateTime";
    SortType[SortType["Caller"] = 3] = "Caller";
    SortType[SortType["RingTo"] = 4] = "RingTo";
    SortType[SortType["Tracking"] = 5] = "Tracking";
    SortType[SortType["Duration"] = 6] = "Duration";
    SortType[SortType["Status"] = 7] = "Status";
    SortType[SortType["RenterName"] = 8] = "RenterName";
    SortType[SortType["RenterPhone"] = 9] = "RenterPhone";
    SortType[SortType["RenterEmail"] = 10] = "RenterEmail";
    SortType[SortType["MoveDate"] = 11] = "MoveDate";
    SortType[SortType["ContactVia"] = 12] = "ContactVia";
    SortType[SortType["MaxRent"] = 13] = "MaxRent";
    SortType[SortType["BedsBaths"] = 14] = "BedsBaths";
    SortType[SortType["ReasonForMoving"] = 15] = "ReasonForMoving";
    SortType[SortType["Address"] = 16] = "Address";
})(SortType || (SortType = {}));
/** CoStar.Api.AptsAnalytics.ViewModels.SortOrder */
export var SortOrder;
(function (SortOrder) {
    SortOrder[SortOrder["None"] = 0] = "None";
    SortOrder[SortOrder["Ascending"] = 1] = "Ascending";
    SortOrder[SortOrder["Descending"] = 2] = "Descending";
})(SortOrder || (SortOrder = {}));
